import { Outlet } from "react-router-dom";

export function Test() {
  return (
    <div>
      <Outlet />
    </div>
  );
}
